<script>
    export default {
        inserted: function (el) {
            let tabs = el.querySelectorAll('ul.tabs li');
            let content = el.querySelectorAll('.tab-content');

            let setOnClick = function (element, index) {
                element.onclick = function (e) {
                    for (let i = 0; i < tabs.length; i++) {
                        tabs[i].classList.remove('active');
                        content[i].style.display = 'none';
                    }

                    for (let i = 0; i < tabs.length; i++) {
                        if (i === index) {
                            tabs[i].classList.add('active');
                            content[i].style.display = 'block';
                        }
                    }

                }
            }
            for (let i = 0; i < tabs.length; i++) {
                setOnClick(tabs[i], i);
            }
        }
    }

</script>
